import React, { useCallback } from 'react';
import {
  MessageEditor,
  MessageEditorSubmitParams,
} from '@fashionnovateam/nova-ui-toolkit';
import {
  ChatConversation,
  ChatMessageTiptapAttributes,
  useChatContext,
  useConversationUsers,
} from '../../Chat';

export function MessageInput(props: { conversation: ChatConversation }) {
  const { conversation } = props;
  const { userId, identity } = useChatContext();

  const usersProcess = useConversationUsers(userId, conversation.instance);

  const queryUsers = (query: string) => {
    const users = usersProcess.map((u) => ({
      id: u.data?.identity || '',
      name: u.data?.friendlyName || '',
      type:
        u.data?.attributes.type === 'vp'
          ? ('vendor' as const)
          : ('fn_internal' as const),
    }));
    return users.filter((u) =>
      u.name.toLowerCase().includes(query.toLowerCase()),
    );
  };

  const sendMessage = useCallback(
    async (params: MessageEditorSubmitParams) => {
      const attributes: ChatMessageTiptapAttributes = {
        type: 'tiptap',
        preview: params.text.slice(0, 50),
      };

      const message = conversation.instance
        .prepareMessage()
        .setBody(JSON.stringify(params.json))
        .setAttributes(attributes);

      params.files.forEach((file, index) => {
        if (file.size === 0) {
          throw new Error('You cannot send an empty file.');
        }
        const formData = new FormData();
        formData.append(`file-${index + 1}`, file, file.name);
        message.addMedia(formData);
      });

      await message.build().send();
    },
    [conversation.instance],
  );
  // TODO query PO

  return (
    <div className="flex-none p-4 border-t border-neutral-300 w-full max-w-[620px]">
      <MessageEditor
        onSubmit={sendMessage}
        placeholder="Leave a message"
        mentionUser={{
          userId: identity,
          queryUsers,
        }}
        fileOptions={{
          maximumFiles: 10,
        }}
      />
    </div>
  );
}
